import classNames from 'classnames';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import { ReactComponent as ArrowIcon } from '@app/pmi/src/assets/media/caret.svg';

import { TProductCategory } from '@lib/core/products/types';
import { isProductCategory } from '@lib/tools/shared/helpers/interfaces';

interface ProductCategoriesDropDownProps {
  productCategories: string[];
  selectedProductCategory: string;
  setSelectedProductCategory: Dispatch<SetStateAction<TProductCategory>>;
}

const ProductCategoriesDropDown = ({
  productCategories,
  selectedProductCategory,
  setSelectedProductCategory,
}: ProductCategoriesDropDownProps) => {
  const isMobileResolution = useMediaQuery({ maxWidth: 767 });
  const [isVisible, setIsVisible] = useState(false);

  const handleProductCategory = (item: string) => {
    if (!isProductCategory(item)) return;
    setSelectedProductCategory(item);
    setIsVisible(false);
  };

  return (
    <div className="dropdown-ds">
      <button
        className={`dropdown-toggle-ds text-uppercase ${isMobileResolution ? 'font-ta-v2-custom-small-header-bold' : 'font-ta-v2-global-caption-medium'}`}
        type="submit"
        onClick={() => setIsVisible(!isVisible)}
      >
        {selectedProductCategory}
        <ArrowIcon
          className={classNames('toggle-icon', {
            open: isVisible,
          })}
        />
      </button>
      <div
        className={classNames('dropdown-menu-ds', {
          open: isVisible,
        })}
      >
        {productCategories.map((item, index) => (
          <button
            key={index}
            className={`dropdown-menu-ds-btn ${isMobileResolution ? 'font-ta-v2-global-regulatory-text-medium' : 'font-ta-v2-global-body-large'}`}
            type="button"
            value={item}
            onClick={() => {
              handleProductCategory(item);
            }}
            onKeyDown={() => {
              handleProductCategory(item);
            }}
          >
            <p className="mb-0 text-uppercase ta-dropdown-text">{item}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

interface Props {
  productCategories: string[];
  selectedProductCategory: string;
  setSelectedProductCategory: Dispatch<SetStateAction<TProductCategory>>;
}
export const ProductCategories: FC<Props> = ({
  productCategories,
  selectedProductCategory,
  setSelectedProductCategory,
}) => (
  <>
    {productCategories.length > 1 ? (
      <ProductCategoriesDropDown
        productCategories={productCategories}
        selectedProductCategory={selectedProductCategory}
        setSelectedProductCategory={setSelectedProductCategory}
      />
    ) : null}
  </>
);
